export default __webpack_public_path__ + "assets/images/money-with-hand.svg";